var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { attrs: { "data-test": "phase-name" } }, [
      _vm._v("\n    " + _vm._s(_vm._f("formatNoData")(_vm.phaseName)) + "\n  "),
    ]),
    _vm._v(" "),
    _c("td", { attrs: { "data-test": "evaluation-name" } }, [
      _vm._v(
        "\n    " + _vm._s(_vm._f("formatNoData")(_vm.evaluationName)) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("td", {
      staticClass: "pega-pre-wrap",
      attrs: { "data-test": "evaluation-comment" },
      domProps: {
        textContent: _vm._s(
          _vm.$options.filters.formatNoData(_vm.evaluationComment)
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }